<tt-page *ngIf="!!edit">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-input ttLabel="labour_name" [ttModel]="edit.labour_name" ttReadonly></tt-input>

            <div [hidden]="edit.message_text_out === '0' || edit.stamped === '0'">
                <tt-textarea ttLabel="message_text_out" [ttModel]="edit.message_text_out" ttReadonly></tt-textarea>
            </div>

            <div [hidden]="edit.overtime_hours === '0.00'">
                <tt-input ttLabel="overtime_hours" [ttModel]="edit.overtime_hours" ttReadonly></tt-input>
                <tt-checkbox ttLabel="overtime_to_personal_timeaccount" [(ttModel)]="edit.overtime_to_personal_timeaccount"></tt-checkbox>
            </div>

            <div *ngIf="argType !== 'exit'">
                <tt-textarea ttLabel="message_text_new" [ttModel]="edit.message_text" ttReadonly></tt-textarea>
            </div>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <div *ngIf="edit.missingexit === '1'">
                <tt-datetime ttLabel="timestamp_out_corrected" [(ttModel)]="edit.timestamp_out_corrected" (ttModelChange)="onChanged($event, 'timestamp_out_corrected')"></tt-datetime>
            </div>

            <tt-textarea ttLabel="job_note" [ttModel]="edit.job_note" ttReadonly></tt-textarea>
            <tt-select ttLabel="planned_offdutycode" [(ttModel)]="edit.offdutycode_keyno" (ttModelChange)="onChanged($event, 'offdutycode_keyno')" [ttData]="selectListOffDutyCodes" ttDataId="item_id" ttDataName="item_name" ttShowClearButton></tt-select>

            <div [hidden]="edit.offdutycode_specification_required === '0'">
                <tt-textarea ttLabel="offdutycode_specification" [(ttModel)]="edit.offdutycode_specification"></tt-textarea>
            </div>
        </tt-card>

        <tt-list-legacy class="col-xs-12 col-md-4 p-5" [listItems]="itemsListExtraPowTimes" ltype="mark"></tt-list-legacy>
    </div>

    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-8 p-5">
            <tt-button-save ttText="confirm" (ttClick)="confirmChanges()" [ttLoading]="confirming"></tt-button-save>
            <tt-button ttText="interrupt" (ttClick)="cancelToTrStart()" ttIcon="fa fa-chevron-left" ttIconAlign="left" ttType="danger"></tt-button>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-button-goto [ttText]="'trnewjobconf_jobnote'" [ttGoto]="'labourjobnote'" [ttGotoParms]="{ labour_no: edit.labour_no }"></tt-button-goto>
        </tt-card>
    </div>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-input class="col-xs-12 sp-0" tt-label="labour_name" tt-model="vm.model.edit.labour_name" tt-change="vm.model.edit.labour_name = $value" tt-readonly="true"></tt-input>

            <div ng-hide="vm.model.edit.message_text_out === '0' || vm.model.edit.stamped === '0'">
                <tt-textarea class="col-xs-12 sp-0" tt-label="message_text_out" tt-model="vm.model.edit.message_text_out" tt-change="vm.model.edit.message_text_out = $value" tt-readonly="true"></tt-textarea>
            </div>

            <div ng-hide="vm.model.edit.overtime_hours === '0.00'">
                <tt-input class="col-xs-12 sp-0" tt-label="overtime_hours" tt-model="vm.model.edit.overtime_hours" tt-change="vm.model.edit.overtime_hours = $value" tt-readonly="true"></tt-input>
                <tt-checkbox class="col-xs-12 sp-0" tt-label="overtime_to_personal_timeaccount" tt-model="vm.model.edit.overtime_to_personal_timeaccount" tt-change="vm.model.edit.overtime_to_personal_timeaccount = $value"></tt-checkbox>
            </div>

            <div ng-if="vm.model.argType !== 'exit'">
                <tt-textarea class="col-xs-12 sp-0" tt-label="message_text_new" tt-model="vm.model.edit.message_text" tt-change="vm.model.edit.message_text = $value" tt-readonly="true"></tt-textarea>
            </div>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <div ng-if="vm.model.edit.missingexit === '1'">
                <tt-datetime class="col-xs-12 sp-0" tt-label="timestamp_out_corrected" tt-model="vm.model.edit.timestamp_out_corrected" tt-change="vm.onChanged($value, 'timestamp_out_corrected')" tt-date-options="{ date: {show: true, disabled: false, align: 'right'}, hour: {show: true, disabled: false, align: 'right'}, minute: {show: true, disabled: false, align: 'right', interval: 1}}"></tt-datetime>
            </div>

            <tt-textarea class="col-xs-12 sp-0" tt-label="job_note" tt-model="vm.model.edit.job_note" tt-change="vm.model.edit.job_note = $value" tt-readonly="true"></tt-textarea>
            <tt-select-buttons class="col-xs-12 sp-0" tt-label="planned_offdutycode" tt-model="vm.model.edit.offdutycode_keyno" tt-change="vm.onChanged($value, 'offdutycode_keyno')" tt-data="vm.model.selectListOffDutyCodes" tt-data-id="item_id" tt-data-name="item_name" tt-buttons="vm.model.offDutyCodeButtons"></tt-select-buttons>

            <div ng-show="vm.model.edit.offdutycode_specification_required === '1'">
                <tt-textarea class="col-xs-12 sp-0" tt-label="offdutycode_specification" tt-model="vm.model.edit.offdutycode_specification" tt-change="vm.model.edit.offdutycode_specification = $value" tt-readonly="false"></tt-textarea>
            </div>
        </tt-card>

        <tt-list class="col-xs-12 col-md-4 p-5" list-items="vm.model.itemsListExtraPowTimes" badge="" ltype="mark" design-var="s12t0"></tt-list>
    </div>

    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-8 p-5">
            <tt-button-save class="col-xs-12 sp-0" tt-text="confirm" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
            <tt-button class="col-xs-12 sp-0" tt-text="interrupt" tt-locked="" tt-click="vm.cancelToTrStart()" tt-icon="" tt-type="danger" tt-text-align="center"></tt-button>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-button-goto class="col-xs-12 sp-0" tt-text="trnewjobconf_jobnote" tt-goto="labourjobnote" tt-goto-parms="{ labour_no: vm.model.edit.labour_no }" tt-text-align="left"></tt-button-goto>
        </tt-card>
    </div>
</tt-page>-->
